export enum eTypeAsnIncome {
  Fulfillment = 1, // Cumplimiento/Entrega
  Reverse = 2, // Inversa
  UndeliverableOrder = 3, // Imposible Entrega
  Restocking = 4 // Reabastecimiento
}
